import React, {useEffect, useState} from 'react';
import FormSection from 'components/sales/formSection/formSection';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';

const HelperForm = ({
                        handleValue,
                        pocById,
                        getPocData,
                        id,
                        leadId,
                        noTitle,
                        status = [
                            {name: 'Active', id: 1},
                            {name: 'In Active', id: 2},
                        ],
                    }) => {
    const [editVal, setEditVal] = useState({
        id: '',
        lead_id: '',
        name: '',
        designation: '',
        phone_no: '',
        email: '',
        status: '',
    });
    const [helperData, setHelperData] = useState({
        lead_id: '',
        name: '',
        designation: '',
        phone_no: '',
        email: '',
        status: '',
    });

    const handleHelperData = () => {
        if (
            helperData.name !== '' &&
            helperData.designation !== '' &&
            helperData.phone_no !== '' &&
            helperData.email !== '' &&
            helperData.status !== ''
        ) {
            if (id) {
                handleValue({
                    id: id,
                    lead_id: leadId,
                    name: editVal.name,
                    designation: editVal.designation,
                    phone_no: editVal.phone_no,
                    email: editVal.email,
                });
            } else {
                handleValue({
                    ...helperData,
                    lead_id: leadId,
                    name: helperData.name,
                    designation: helperData.designation,
                    phone_no: helperData.phone_no,
                    email: helperData.email,
                    status: helperData.status,
                });
            }
        } else {
            handleValue(null);
        }
    };

    useEffect(() => {
        handleHelperData();
    }, [helperData]);

    useEffect(() => {
        if (pocById) {
            setEditVal(pocById);
        }
    }, [pocById]);


    useEffect(() => {
        if (id) {
            handleValue({
                id: id,
                lead_id: leadId,
                name: editVal.name,
                designation: editVal.designation,
                phone_no: editVal.phone_no,
                email: editVal.email,
                status: editVal.status,
            });
        }
    }, [editVal]);

    return (
        <FormSection
            title={
                id
                    ? localization.helperPocDetail
                    : noTitle
                        ? ''
                        : localization.helperDetailTitle
            }
        >
            <ConstantInput
                value={editVal.name}
                label={localization.HelperName}
                regex={Regex.text.test(helperData.name)}
                errorMsg={'Helper Name is required!'}
                type="text"
                required
                handleChange={(value) => {
                    setHelperData({...helperData, name: value});
                    setEditVal({...editVal, name: value});
                }}
                isStarRequired={true}
            />
            <ConstantInput
                value={editVal.designation}
                label={localization.HelperDesignation}
                regex={Regex.text.test(helperData.designation)}
                errorMsg={'Helper designation is required!'}
                type="text"
                required
                handleChange={(value) => {
                    setHelperData({...helperData, designation: value});
                    setEditVal({...editVal, designation: value});
                }}
                isStarRequired={true}
            />
            <ConstantInput
                value={pocById.id ? `${editVal.phone_no}` : helperData.phone_no}
                label={localization.HelperPhoneNumber}
                regex={Regex.phoneNumber.test(helperData.phone_no)}
                errorMsg={localization.phoneError}
                maxLength={10}
                minLength={10}
                type="text"
                isPrefix
                prefixText={'+91'}
                required
                handleChange={(value) => {
                    setHelperData({...helperData, phone_no: value});
                    setEditVal({...editVal, phone_no: value});
                }}
                isStarRequired={true}
            />
            <ConstantInput
                value={editVal.email}
                label={localization.emailAddress}
                regex={
                    Regex.email.test(helperData.email) || Regex.email.test(editVal.email)
                }
                errorMsg={localization.emailError}
                type="email"
                required
                handleChange={(value) => {
                    setHelperData({...helperData, email: value});
                    setEditVal({...editVal, email: value});
                }}
                isStarRequired={true}
            />
            <DropDownInput
                disabled={status.length === 0}
                label={localization.status}
                data={status}
                required
                value={editVal.status === 1 ? 'Active' : 'In Active'}
                errorMsg={localization.statusErrorMsg}
                getIdValue={(value) => {
                    setHelperData({...helperData, status: value.id});
                    setEditVal({...editVal, status: value.id});
                }}
                isStarRequired={true}
            />
        </FormSection>
    );
};

export default HelperForm;
